@if(allowPreauthorization){
<dropdown-component [config]="configs().dropdown" />
} @else {
<button-component [config]="configs().btn" />
}
